export type TRedactedCustomerResponse = {
  redactedAt: string;
  redactedBy: string;
  redactionReason: string;
  id: string;
  entityType: string;
  customerName?: string | null;
  name?: string | null;
};

export function isRedactedCustomer(
  customer: unknown,
): customer is TRedactedCustomerResponse {
  return (
    customer != null &&
    typeof customer === 'object' &&
    'redactedAt' in customer &&
    typeof (customer as Record<string, unknown>).redactedAt === 'string'
  );
}
